import { render, staticRenderFns } from "./BookmarkNeedMore.vue?vue&type=template&id=73f5ac06&scoped=true"
import script from "./BookmarkNeedMore.vue?vue&type=script&lang=js"
export * from "./BookmarkNeedMore.vue?vue&type=script&lang=js"
import style0 from "./BookmarkNeedMore.vue?vue&type=style&index=0&id=73f5ac06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f5ac06",
  null
  
)

export default component.exports